import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { projectImages } from './projectImages';
import { motion } from 'framer-motion';
import './work.css';

export default function WorkParent() {
  const { t } = useTranslation();
  const workItems = t('work.workItems', { returnObjects: true });

  // Group rows for animation (2 cards per row)
  const workArray = Object.entries(workItems);
  const grouped = [];
  for (let i = 0; i < workArray.length; i += 2) {
    grouped.push(workArray.slice(i, i + 2));
  }

  return (
    <div className='child-page-wrapper'>
      <h1>
        {t('work.h1')}
      </h1>
        {grouped.map((row, rowIndex) => (
          <motion.div
            key={rowIndex}
            className='work-row'
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6, ease: 'easeOut', delay: rowIndex * 0.3 }}
          >
            {row.map(([key, work]) => {
              const imgSrc = projectImages[key];
              return (
                <div key={key} className='work-card'>
                  <NavLink
                    to={`/work/${key}`}
                    className='work-card-link'
                    end
                  >
                    <article>
                      <figure className='work-img'>
                        <img 
                          src={imgSrc} 
                          alt=''
                          role='presentation'
                        />
                      </figure>

                      <h2 className='work-title'>
                        {work.title}
                      </h2>

                        <ul className='work-tags' aria-label='Roles'>
                          {Array.isArray(work.tag) &&
                            work.tag.map((tag, i) => (
                              <li key={i} className='work-tag-item'>
                                {tag}
                              </li>
                            ))}
                        </ul>
                    </article>
                  </NavLink>
                </div>
              );
            })}
          </motion.div>
        ))}

    </div>
  );
}
